export const SESSION_KEY_CHAT_OPEN_STATE = '__chat_open_state';
export const SESSION_KEY_ID = '__session_id';
export const SESSION_KEY_CHAT_HISTORY = '__chat_history';
export const SESSION_KEY_CHAT_BOT_GREETED = '__chat_greeted';
export const EVIE_POSITION = '__evie_position';
export const CHAT_ERROR_RESPONSE_MSG = 'I\'m currently grabbing a coffee and away from my desk. Don\'t worry, I\'ll be back soon! In the meantime, reach out to support for any immediate questions or concerns.';
export const CHAT_BOT_WELCOME_MSG = 'Hey there! I’m Evie. Your virtual assistant. How can I help?';
